import { HeaderProps } from './Header'
import Header from './Header'
export default Header
export type { HeaderProps }
